import axios from "axios";

export default function ScheduleitemsProductionItemDeleteService(scheduleItemId, productionJobId) {
  return axios({
    method: 'delete',
    url: process.env.REACT_APP_API_HOST + "/schedule_item/" + scheduleItemId + "/production_job/" + productionJobId,
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
